module.exports = __webpack_public_path__ + "static/media/footer-icon-discord.eba33b09.svg";